import { httpClient } from "@/lib/http-client/http-client";
import { API_ROUTES } from "@/shared/constants/api.routes";
import { IGetActivityLogsRequest, IGetConflictResolutionPerformanceRequest, IGetContributionPerformanceRequest, IGetDashboardStatisticsRequest, IGetLastActivitiesRequest, IGetProcessedResourcesRequest, IGetSpecificationItemSourcesRequest } from "../interface/requests/dashboard";
import { IActivityLogsResponse, IDashboardStatisticsResponse, IGetConflictResolutionPerformanceResponse, IGetContributionPerformanceResponse, IGetLastActivitiesResponse, IGetProcessedResourcesResponse, IGetSpecificationItemSourcesResponse } from "../interface/responses/dashboard";

class DashboardService {
  async getDashboardStatistics(request: IGetDashboardStatisticsRequest) {
    const params = new URLSearchParams();
    if (request.folderId) {
      params.append("folderId", request.folderId);
    }
    if (request.specificationId) {
      params.append("specificationId", request.specificationId);
    }
    if (request.startDate) {
      params.append("startDate", request.startDate);
    }
    if (request.endDate) {
      params.append("endDate", request.endDate);
    }

    const response = await httpClient.get<IDashboardStatisticsResponse>(
      API_ROUTES.Dashboard.statistics(request.companyId) +
      "?" +
      params.toString()
    );
    return response;
  }

  async getActivityLogs(request: IGetActivityLogsRequest) {
    const params = new URLSearchParams();
    if (request.folderId) {
      params.append("folderId", request.folderId);
    }
    if (request.specificationId) {
      params.append("specificationId", request.specificationId);
    }
    if (request.startDate) {
      params.append("startDate", request.startDate);
    }
    if (request.endDate) {
      params.append("endDate", request.endDate);
    }
    const response = await httpClient.get<IActivityLogsResponse>(
      API_ROUTES.Dashboard.activityLogs(request.companyId) +
      "?" +
      params.toString()
    );
    return response;
  }

  async getSpecificationItemSources(request: IGetSpecificationItemSourcesRequest) {
    const params = new URLSearchParams();
    if (request.folderId) {
      params.append("folderId", request.folderId);
    }
    if (request.specificationId) {
      params.append("specificationId", request.specificationId);
    }
    if (request.startDate) {
      params.append("startDate", request.startDate);
    }
    if (request.endDate) {
      params.append("endDate", request.endDate);
    }
    const response = await httpClient.get<IGetSpecificationItemSourcesResponse>(
      API_ROUTES.Dashboard.specificationItemSources(request.companyId) +
      "?" +
      params.toString()
    );
    return response;
  }

  /* /dashboard/{companyId}/last-activities */
  async getLastActivities(request: IGetLastActivitiesRequest) {
    const params = new URLSearchParams();
    if (request.folderId) {
      params.append("folderId", request.folderId);
    }
    if (request.specificationId) {
      params.append("specificationId", request.specificationId);
    }
    if (request.startDate) {
      params.append("startDate", request.startDate);
    }
    if (request.endDate) {
      params.append("endDate", request.endDate);
    }
    if (request.term) {
      params.append("term", request.term);
    }
    const response = await httpClient.get<IGetLastActivitiesResponse>(
      API_ROUTES.Dashboard.lastActivities(request.companyId) +
      "?" +
      params.toString()
    );
    return response;
  }

  async getProcessedResources(request: IGetProcessedResourcesRequest) {
    const params = new URLSearchParams();
    if (request.folderId) {
      params.append("folderId", request.folderId);
    }
    if (request.specificationId) {
      params.append("specificationId", request.specificationId);
    }
    if (request.startDate) {
      params.append("startDate", request.startDate);
    }
    if (request.endDate) {
      params.append("endDate", request.endDate);
    }
    const response = await httpClient.get<IGetProcessedResourcesResponse>(
      API_ROUTES.Dashboard.processedResources(request.companyId) +
      "?" +
      params.toString()
    );
    return response;
  }

  /* /dashboard/{companyId}/contribution-performance */
  async getContributionPerformance(request: IGetContributionPerformanceRequest) {
    const params = new URLSearchParams();
    if (request.folderId) {
      params.append("folderId", request.folderId);
    }
    if (request.specificationId) {
      params.append("specificationId", request.specificationId);
    }
    if (request.startDate) {
      params.append("startDate", request.startDate);
    }
    if (request.endDate) {
      params.append("endDate", request.endDate);
    }
    const response = await httpClient.get<IGetContributionPerformanceResponse>(
      API_ROUTES.Dashboard.contributionPerformance(request.companyId) +
      "?" +
      params.toString()
    );
    return response;
  }

  async getConflictResolutionPerformance(request: IGetConflictResolutionPerformanceRequest) {
    const params = new URLSearchParams();
    if (request.folderId) {
      params.append("folderId", request.folderId);
    }
    if (request.specificationId) {
      params.append("specificationId", request.specificationId);
    }
    if (request.startDate) {
      params.append("startDate", request.startDate);
    }
    if (request.endDate) {
      params.append("endDate", request.endDate);
    }
    const response = await httpClient.get<IGetConflictResolutionPerformanceResponse>(
      API_ROUTES.Dashboard.conflictResolutionPerformance(request.companyId) +
      "?" +
      params.toString()
    );
    return response;
  }
}

export const dashboardService = new DashboardService();
